module.exports = __webpack_public_path__ + "img/width_facing_hood.e88ecd53.png";